import * as React from 'react';
import Loader from '../_common/loader';
import APIManager from '../../utilities/api-manager';

const BluePrintVisualizationContainer = React.lazy(() => import('../dataset-section-components/dataset-visualization/blueprint-visualization'));

const bluePrintVisualizationSection = function BluePrintVisualizationSection({
    isBundle,
    isLoggedIn,
    isTableauSessionCreated,
    scrollTo,
    dataSectionType,
    dataVisualization,
    MarketplaceBlueprintDefaultImage,
    VidyardVideoID,
    accessToken,
    isChromeIncognitoMode,
    onUnauthorizedResponse,
    PlotlySampleAppPath,
    isPendingOktaSignIn,
    MarketplaceBlueprintName,
    MarketplaceBlueprintDemoId,
    dataNotebooks
}: BluePrintVisualizationSectionProps) {
    const [embedContent, setEmbedContent] = React.useState<PowerBIEmbedContent[]>([]);

    React.useEffect(() => {
        const fetchPowerBIEmbedContentData = async (id: string) => {
            const response = await APIManager.getPowerBIEmbedInfo(id);
            return response.data;
        };
        let powerbiViz: any[] = [];

        if (dataVisualization) {
            powerbiViz = dataVisualization.filter(viz => viz.VisualizationType === 'POWERBI');
        }

        const fetchAllEmbedContent = async () => {
            try {
                const results = await Promise.all(powerbiViz.map(viz => fetchPowerBIEmbedContentData(viz.ReportId)));
                setEmbedContent(results);
            } catch (error) {
                console.error('Failed to fetch PowerBI Embed Content Data:', error);
            }
        };

        fetchAllEmbedContent();

        const intervalId = setInterval(fetchAllEmbedContent, 55 * 60 * 1000);

        return () => clearInterval(intervalId);
    }, []);

    return (
        <React.Suspense fallback={<Loader minHeight="700px" />}>
            <BluePrintVisualizationContainer
                isTableauSessionCreated={isTableauSessionCreated}
                isLoggedIn={isLoggedIn}
                isBundle={isBundle}
                scrollTo={scrollTo}
                dataSectionType={dataSectionType}
                dataVisualization={dataVisualization}
                powerBIEmbedContent={embedContent}
                MarketplaceBlueprintDefaultImage={MarketplaceBlueprintDefaultImage}
                VidyardVideoID={VidyardVideoID}
                accessToken={accessToken}
                isChromeIncognitoMode={isChromeIncognitoMode}
                onUnauthorizedResponse={onUnauthorizedResponse}
                PlotlySampleAppPath={PlotlySampleAppPath}
                isPendingOktaSignIn={isPendingOktaSignIn}
                MarketplaceBlueprintName={MarketplaceBlueprintName}
                MarketplaceBlueprintDemoId={MarketplaceBlueprintDemoId}
                dataNotebooks={dataNotebooks}
            />
        </React.Suspense>
    );
};

export default React.memo(bluePrintVisualizationSection);
